import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import { TOTAL_STEPS } from '../store';
import { WizardStepsProps } from '../types';
import styles from './styles.module.css';

export const WizardSteps: FC<WizardStepsProps> = ({
  activeStep,
  setActive,
}) => {
  const renderStepBubble = (stepNumber: number) => {
    const isDone = activeStep > stepNumber;
    const isActive = stepNumber === activeStep;

    return (
      <li
        key={stepNumber}
        className={clsx(styles.listItem, {
          [styles.isDone]: isDone,
          [styles.isActive]: isActive,
        })}
      >
        {isDone ? (
          <Icon className={styles.tickIcon} type={IconType.check} />
        ) : (
          <Span className={styles.digit}>{stepNumber}</Span>
        )}
      </li>
    );
  };

  return (
    <div className={styles.root}>
      <div
        onClick={() => setActive(activeStep - 1)}
        className={clsx(styles.progressBack, {
          [styles.isActive]: activeStep > 1,
        })}
      >
        <Icon type={IconType.arrowLongLeft} />
      </div>

      <ol className={styles.progressBubbles}>
        {TOTAL_STEPS.map(renderStepBubble)}
      </ol>
    </div>
  );
};
